export const SECONDARY_WALLET_ENABLED =
  process.env.REACT_APP_ENABLE_SECONDARY_WALLET !== "false";